import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayoutSwapHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 12.5h8.5m-8.5 0 2.75 3m-2.75-3 2.75-3m11.75-2h-8.5m8.5 0-2.75-3m2.75 3-2.75 3"
	})]
});
const ForwardRef = forwardRef(SvgLayoutSwapHorizontal);
export { ForwardRef as ReactComponent };
